import { render } from "./SocialLinks.vue?vue&type=template&id=072965ce&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=072965ce&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072965ce"]])

export default __exports__